import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { TemporalidadeModel } from './temporalidade.model';

@Injectable()
export class TemporalidadeServiceService {

  public apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private http: HttpClient) { }

  listTemporalidade(nodeId: Number): Observable<Array<TemporalidadeModel>> {
    return this.http.get<Array<TemporalidadeModel>>(this.apiURL + `/temporalidade/list/${nodeId}`, this.httpOptions);
  }

  saveTemporalidade(temporalidade: TemporalidadeModel): Observable<TemporalidadeModel> {
    return this.http.post<TemporalidadeModel>(this.apiURL + `/temporalidade/save`, temporalidade, this.httpOptions);
  }

  deleteTemporalidade(id: Number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'))
    .set('Content-Type', 'application/json');

    return this.http.delete(this.apiURL + `/temporalidade/delete/${id}`, { headers, responseType: 'text' });
  }

  editTemporalidade(temporalidade: TemporalidadeModel): Observable<TemporalidadeModel> {
    return this.http.put<TemporalidadeModel>(this.apiURL + `/temporalidade/edit`, temporalidade, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/temporalidade/temporalidade-service.service.ts